import React, { useState } from 'react';
import { useParams } from 'react-router';

import { newPassword } from 'actions';
import useActions from 'hooks/useActions';
import PublicPage from 'components/PublicPage';
import { default as NewPasswordForm } from 'forms/NewPassword';


const NewPassword = ({navbarProps}) => {
  const { token } = useParams();
  const dispatchNewPassword = useActions(newPassword);

  const [passwordReseted, setPasswordReseted] = useState(false);
  const onSuccess = () => {
    setPasswordReseted(true);
  }

  const onSubmit = (values) => {
    dispatchNewPassword({...values, token}, {onSuccess});
  }

  return (
    <PublicPage navbarProps={navbarProps}>
      <div className="container py-6">
        <div className="box my-6">
          {!passwordReseted ?
          <NewPasswordForm onSubmit={onSubmit}/>
          :
          <div className="content">
            <p>Votre mot de passe a été changé, vous pouvez à présent vous connecter</p>
          </div>
          }
        </div>
      </div>
    </PublicPage>
  )
}

export default NewPassword;